import React, { memo } from "react";

import { Spinner } from "@chakra-ui/react";
import moment from "moment";
import InviteForm from "./invite-form";
import InviteExpired from "./invite-expired";
import useQueryString from "modules/hooks/use-query-string";
import InviteSuccess from "./invite-success";
import useInvite from "./use-invite";

interface IProps {
  inviteId: string;
}

const Invite = ({ inviteId }: IProps) => {
  const { qsIsSuccess } = useQueryString();

  const { invite } = useInvite({ inviteId });

  const isExpired = invite?.expireTime
    ? moment().isAfter(moment(invite?.expireTime))
    : false;

  if (!invite) {
    return <Spinner />;
  }

  if (isExpired) {
    return <InviteExpired />;
  }

  if (qsIsSuccess) {
    return <InviteSuccess />;
  }

  return <InviteForm invite={invite} />;
};

export default memo(Invite);
